module.exports = __webpack_public_path__ + "static/media/logo.8e76086e.jpeg";